module.exports = __webpack_public_path__ + "static/media/pic7.b0bbed11.jpg";